












import Vue from 'vue'
import Options from './ExperimentOptions.vue'

export default Vue.extend({
  name: 'Summary',
  props: ['dataset'],
  components: {
    Options
  },
  computed: {
    nrSpectras() {
      return Object.keys(this.dataset.corpus).length;
    },
    nrMotifs() {
      return Object.keys(this.dataset.topic_metadata).length;
    }
  }
})
